import { useState } from "react";
import { Reveal } from "./Reveal";
import { GALLERY } from "@/lib/site";

const FILTERS = [
  ["all", "All Projects"],
  ["interiors", "Interiors"],
  ["exteriors", "Exteriors"],
];

export default function Gallery() {
  const [filter, setFilter] = useState("all");
  const items = filter === "all" ? GALLERY : GALLERY.filter((g) => g.cat === filter);

  return (
    <section id="gallery" className="bg-graybg py-20 md:py-28">
      <div className="mx-auto max-w-[1200px] px-5 md:px-8">
        <Reveal>
          <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
            <div>
              <p className="eyebrow">Gallery</p>
              <h2 className="mt-4 font-display text-4xl font-light leading-[1.12] text-navy md:text-5xl">
                Real projects. <em className="italic">Real Central Florida homes.</em>
              </h2>
            </div>
            <div className="flex flex-wrap gap-2.5">
              {FILTERS.map(([key, label]) => (
                <button
                  key={key}
                  data-testid={`gallery-filter-${key}`}
                  onClick={() => setFilter(key)}
                  className={`chip ${filter === key ? "active" : ""}`}
                >
                  {label}
                </button>
              ))}
            </div>
          </div>
        </Reveal>

        <div className="mt-12 columns-1 gap-5 sm:columns-2 lg:columns-3">
          {items.map((g, i) => (
            <Reveal key={g.img + filter} delay={(i % 6) * 0.05} className="mb-5 break-inside-avoid">
              <div className="group overflow-hidden bg-white">
                <img
                  src={g.img}
                  alt={g.alt}
                  loading="lazy"
                  className="w-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-[1.04]"
                />
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
